import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M16.175 13H5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 12q0-.424.287-.713A.97.97 0 0 1 5 11h11.175l-4.9-4.9a.92.92 0 0 1-.287-.7Q11 5 11.3 4.7q.3-.275.7-.288t.7.288l6.6 6.6q.15.15.212.325.063.175.063.375c0 .2-.02.258-.063.375a.9.9 0 0 1-.212.325l-6.6 6.6a.93.93 0 0 1-.688.275 1.02 1.02 0 0 1-.712-.275q-.3-.3-.3-.713 0-.412.3-.712z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }